"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatNodes;

function indentRecursive(node) {
  var indent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  node.each && node.each(function (child, i) {
    if (!child.raws.before || child.raws.before.includes('\n')) {
      child.raws.before = "\n".concat(node.type !== 'rule' && i > 0 ? '\n' : '').concat('  '.repeat(indent));
    }

    child.raws.after = "\n".concat('  '.repeat(indent));
    indentRecursive(child, indent + 1);
  });
}

function formatNodes(root) {
  indentRecursive(root);

  if (root.first) {
    root.first.raws.before = '';
  }
}